import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/table";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import i18n from "i18next";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import { findRankStatusChangesV2 } from "../../../../shared/functions/standing";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const standing = _.get(dynamic, "standing");
  const cleanSheets = _.get(dynamic, "cleanSheets");
  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));
  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];

  const teamSide = getContentById("selectedSide", fields);
  const rankingType = getContentById("rankingType", fields);
  const groupType = getContentById("groupType", fields);
  let targetTeamId = teamSide === "home" ? homeTeam?.TeamId : awayTeam?.TeamId;
  if (!targetTeamId) {
    targetTeamId = 'DFL-CLU-J00001'; // Germany by default
  }

  const gruppe = _.find(standing, (group) => {
    const isGroupStage = group?.Group?.includes('GROUP');
    const hasTeam = _.some(group?.Entry, { ClubId: targetTeamId });

    return isGroupStage && hasTeam;
  });
  const allGroups = _.filter(standing, (group) => {
    const isGroupStage = group?.Group?.includes('GROUP');
    return isGroupStage
  });
  const allTeams = _.flatMap(allGroups, group => group.Entry || []);
  const global = {
    Entry: allTeams
  };
  let findGroup = groupType === 'Global' ? global : gruppe
  const competitionId = matchInfo?.competition?.id;
  const lng = i18n?.language;
  if (findGroup) {
    findGroup.Entry = findGroup.Entry.sort((a, b) => {
      if (Number(b.GoalsScored) !== Number(a.GoalsScored)) {
        return Number(b.GoalsScored) - Number(a.GoalsScored);
      }

      return Number(a.GoalsAgainst) - Number(b.GoalsAgainst);
    })?.slice(0, 5);
  }
  let findSheets = groupType === 'Global' ? cleanSheets?.['global'] : cleanSheets?.['global'];
  const goalTitle = `${t('Goals', { keyPrefix: 'stats' })}${groupType === 'Global'
    ? ''
    : ` - ${findGroup?.Group?.replace(
      /GROUP\s?/,
      `${t('Group', { keyPrefix: 'templates' })} `
    )}`
    }`;
  let previousRank = 1;
  const cleanSheetsTitle = t('player_cleanSheet', { keyPrefix: "rankingLabels" });
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        {/*<WcBgCircle />*/}
        <div
          className={`wc-content wc-content-v2 wc-standing-container competition-${competitionId}`}
        >
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className="wc-standing-header">
            <div className={"competition-positioner"}>
              <div className={"competition-logo-container"}>
                <Image
                  src={`/images/dynamic/soccer/competition/fifa-2026-worldcup.svg`}
                />
              </div>
              <div className="second-title">
              </div>
            </div>
            <div className="main-title">

              {rankingType === 'Goal' ? goalTitle : cleanSheetsTitle}
            </div>
          </div>

          <div className={"group-table"}>
            <div className={"group-content"}>
              <div className={"table-head"}>
                <div className={"col-pos col"}></div>
                <div className={"col-team col"}></div>
                <div className={"col-pkt col"}>
                  {rankingType === 'Goal' ? t("Goals", { keyPrefix: "stats" }) : t("player_cleanSheet", { keyPrefix: "rankingLabels" })}
                </div>
                <div className={"col-points col"}>
                  {t("goalsConceded", { keyPrefix: "stats" })}
                </div>
              </div>
              {rankingType === 'Goal' ? findGroup?.Entry?.map((entry, index, arr) => {
                let rank = 1;

                if (
                  index > 0 &&
                  entry.GoalsScored === arr[index - 1].GoalsScored &&
                  entry.GoalsAgainst === arr[index - 1].GoalsAgainst
                ) {
                  rank = previousRank; // Same rank
                } else if (index > 0) {
                  rank = previousRank + 1; // Next dense rank
                  previousRank = rank;
                }
                return (
                  <div
                    key={"table-" + index}
                    className={`table-row`}
                  >
                    <div className={"col-pos col"}>{rank}.</div>
                    <div className={"col-team col"}>
                      <div className={"col-logo"}>
                        <Image
                          className="team-logo"
                          src={getDynamicLogoPath({
                            team: {
                              TeamId: entry?.ClubId,
                              TeamName: entry?.Club,
                              ThreeLetterCode: entry?.ThreeLetterCode
                            },
                            competitionId,
                          })}
                        />
                      </div>
                      {t(entry?.Club || entry?.ShortName, {
                        ns: "countries",
                      }) || entry?.contestantName}
                    </div>
                    <div className={"col-pkt col"}>
                      {entry.GoalsScored}
                    </div>
                    <div className={"col-points col"}>{entry.GoalsAgainst}</div>
                  </div>
                );
              }) : findSheets?.map((entry, index) => {
                const playerName = entry?.PlayerAlias ? entry?.PlayerAlias : entry?.PlayerFirstName ? entry?.PlayerFirstName + ' ' + entry?.PlayerLastName : entry?.PlayerlastName;
                return (
                  <div
                    key={"table-" + index}
                    className={`table-row`}
                  >
                    <div className={"col-pos col"}>{++index}.</div>
                    <div className={"col-team col"}>
                      <div className={"col-logo"}>
                        <Image
                          className="team-logo"
                          src={getDynamicLogoPath({
                            team: {
                              TeamId: entry?.TeamId,
                              TeamName: entry?.TeamName,
                              ThreeLetterCode: entry?.teamThreeLetterCode
                            },
                            competitionId,
                          })}
                        />
                      </div>
                      {playerName}
                    </div>
                    <div className={"col-pkt col"}>
                      {entry.CleanSheets}
                    </div>
                    <div className={"col-points col"}>{entry.GoalsConceded}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_1920`);
};

export default Index;
